import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CallbackComponent } from "./authentication/components/callback/callback.component";
import { LoginComponent } from "./authentication/components/login/login.component";
import { SsoLogoutComponent } from "./authentication/components/sso-logout/sso-logout.component";
import { SecurityGuard } from "./authentication/guards/security.guard";

const routes: Routes = [
  { path: "", redirectTo: "property-dashboard", pathMatch: "full" },
  {
    path: "login",
    data: {
      title: "Login",
    },
    component: LoginComponent,
  },
  {
    path: "logout",
    data: {
      title: "Logout",
    },
    component: SsoLogoutComponent,
  },
  {
    path: "callback",
    data: {
      title: "Callback",
    },
    component: CallbackComponent,
  },
  {
    path: "property-dashboard",
    canActivate: [SecurityGuard],
    loadChildren: () => import("./property-management-dashboard/property-management-dashboard.module").then((m) => m.PropertyManagementDashboardModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
